import { createContext } from 'react';

const drawerContext = createContext();

export default drawerContext;

